module.exports = {
  "country": "SE",
  "artist": "Sanna Nielsen",
  "song": "Undo",
  "year": "2014",
  "place": "3",
  "spotify": "1y0Ptl7dOU9sB3ISlJYYpU"
};